import React from 'react';
import PropTypes from 'prop-types';

const InformationTooltip = props => <div className={`information-tooltip${props.additionalClassName !== undefined ? ` ${props.additionalClassName}` : ''}`}>
  <div className={'information-tooltip__icon'}>
    <div className={`information-tooltip__icon__text-container${props.additionalClassName !== undefined ? ` ${props.additionalClassName}` : ''}`}>
      <div className={'information-tooltip__icon__text-container__text'}
           dangerouslySetInnerHTML={{__html: props.text}}/>
    </div>
  </div>
</div>;

InformationTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  additionalClassName: PropTypes.string
};
export default InformationTooltip;
